import React from 'react';
import { faCalendarXmark } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, ToggleButton } from '@mui/material';
import { ColorPalette } from '../../../../../components/config';
import { attendanceButtonColumnMinWidth, attendanceNotRelevantIconFontSize, headerStateLabelStyle, registeredStateLabelOverlayStyle } from './attendance-column-layout';

interface IAttendanceNotRelevantButtonProps {
  selected: boolean;
  onClick: () => void;
  isHeader?: boolean;
  disabled?: boolean;
  locked?: boolean;
  readOnly?: boolean;
}

export function AttendanceNotRelevantButton(props: IAttendanceNotRelevantButtonProps) {
  const { selected, onClick, isHeader = false, disabled = false, locked = false, readOnly = false } = props;

  const showRegisteredStateLabel = selected;

  const backgroundColor = selected && !locked ? ColorPalette.CityNightSkies : 'inherit';

  const iconColor = (() => {
    if (!selected) {
      return 'inherit';
    }
    return locked ? ColorPalette.CityNightSkies : 'white';
  })();
  return (
    <Box display="flex" flexDirection="column" alignItems="center" minWidth={attendanceButtonColumnMinWidth} position="relative">
      <ToggleButton
        value="not-relevant"
        selected={selected}
        aria-label={isHeader ? 'Markér alle som ikke relevant' : 'Markér som ikke relevant'}
        disabled={disabled || locked}
        disableRipple={readOnly}
        sx={{
          cursor: readOnly ? 'default' : undefined,
          width: 34,
          height: 34,
          padding: 0,
          border: 'none',
          borderRadius: '50%',
          backgroundColor,
          '&:hover': {
            backgroundColor,
          },
          '&.Mui-selected': {
            color: locked ? undefined : 'white',
            backgroundColor,
            '&:hover': {
              color: locked ? undefined : 'white',
              backgroundColor,
            },
          },
          '&.Mui-disabled': {
            border: 'none',
            backgroundColor,
            color: locked ? undefined : 'gray',
          },
        }}
        onChange={readOnly ? undefined : onClick}
      >
        <FontAwesomeIcon color={iconColor} icon={faCalendarXmark} fontSize={attendanceNotRelevantIconFontSize} style={{ position: 'relative', top: -1 }} />
      </ToggleButton>
      {isHeader && <Box sx={headerStateLabelStyle}>Ikke relevant</Box>}
      {!isHeader && showRegisteredStateLabel && <Box sx={registeredStateLabelOverlayStyle}>Ikke relevant</Box>}
    </Box>
  );
}
